import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

/**
 * A compact icon button for toggling dark/light mode.
 * Drop it anywhere in a nav header — it reads/writes theme via ThemeContext.
 */
export const ThemeToggle = ({ className = '' }) => {
  const { dark, toggleTheme } = useTheme();
  return (
    <button
      onClick={toggleTheme}
      className={`p-2 rounded-lg bg-white/10 hover:bg-white/20 text-white transition-colors flex-shrink-0 ${className}`}
      title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
};

export default ThemeToggle;
